import React from 'react'

import { formatPlaceTypePermission } from '../../../utils/helpers/placeTypes'
import { useModalData } from '../../../components/modals/ModalsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditPlaceLevelForm from './EditPlaceLevelForm'
import ModalHeader from './ModalHeader'
import PermissionChecker from '../../session/_shared/PermissionChecker'
import PlaceLevelLoader from './_load/PlaceLevelLoader'

const EditPlaceLevelModal = props => {
  const { type } = useModalData() || {}

  return (
    <PermissionChecker permission={'setup' + formatPlaceTypePermission(type)}>
      <ModalHeader />
      <PlaceLevelLoader>
        <EditPlaceLevelForm />
      </PlaceLevelLoader>
    </PermissionChecker>
  )
}

const Wrapper = props => (
  <ControlledModal width="36rem" {...props}>
    <EditPlaceLevelModal {...props} />
  </ControlledModal>
)

export default Wrapper
